/**
 * Редактор статических материалов — разметка 1:1 с legacy
 * htdocs/core/templates/admin_main.tpl (form.add-form, .form-control, #main_text,
 * кнопка «сохранить изменения» .bt.orange).
 *
 * Тем же шаблоном legacy правил и главную (materials name='main', Admin::index),
 * и страницу 404 (materials name='error_404', Admin::error_404, только суперадмин).
 * Какой материал редактируется — определяет URL (/admin/error_404 → 404, иначе главная),
 * маршруты заданы в App.tsx.
 *
 * API: GET/POST /api/admin/content/main, GET/POST /api/admin/content/error404.
 * WYSIWYG summernote заменён на <textarea> в той же обёртке (id=main_text,
 * class=in_editor) — см. notes.
 */

import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { api, ApiError } from '@/api/client'
import { HtmlEditor } from '@/components/HtmlEditor'
import type { Material } from '@/api/types'
import { useLegacyCss } from '@/lib/legacyAssets'
import { useApi } from '@/lib/useApi'

export function AdminPagesPage() {
  useLegacyCss('admin', 'newapproach') // те же стили, что подключал legacy admin.tpl

  const location = useLocation()
  // legacy: разные разделы админки — /admin/ (главная) и /admin/error_404
  const isError404 = location.pathname.endsWith('error_404')
  const endpoint = isError404 ? '/api/admin/content/error404' : '/api/admin/content/main'

  const { data } = useApi<Material | null>(endpoint)

  const [title, setTitle] = useState('')
  const [text, setText] = useState('')
  const [ok, setOk] = useState<string[]>([])
  const [error, setError] = useState<string[]>([])

  useEffect(() => {
    setTitle(data?.title ?? '')
    setText(data?.text ?? '')
  }, [data])

  /** legacy main-submit. */
  const submit = async (): Promise<void> => {
    try {
      const result = await api.post<{ message: string }>(endpoint, { title, text })
      setOk([result.message])
      setError([])
    } catch (e: unknown) {
      setError([e instanceof ApiError ? e.message : 'Ошибка при сохранении'])
      setOk([])
    }
  }

  return (
    <>
      <div className="infobox clearfix">
        {error.map((message, index) => (
          <p key={index} className="okke" style={{ color: '#ce4844', float: 'left' }}>
            {message}
          </p>
        ))}
        {ok.map((message, index) => (
          <p key={index} className="okke" style={{ float: 'left' }}>
            {message}
          </p>
        ))}
      </div>

      <form
        className="add-form"
        method="POST"
        onSubmit={(e) => {
          e.preventDefault()
          void submit()
        }}
      >
        <div className="form-control" style={{ paddingBottom: '6px', display: 'table' }}>
          <span
            style={{ width: '120px', display: 'table-cell', color: '#999', fontSize: '11px' }}
          >
            Заголовок страницы:&nbsp;
          </span>
          <input
            name="title"
            style={{ display: 'table-cell', border: 0, outline: 0, width: '100%' }}
            value={title}
            placeholder="Заголовок"
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <br />
        <HtmlEditor value={text} onChange={setText} />
        <div style={{ textAlign: 'center' }}>
          <input
            type="submit"
            name="main-submit"
            className="bt orange"
            value="сохранить изменения"
          />
        </div>
      </form>
    </>
  )
}
